// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type WarnIfSamlCertExpiringFragment = {
  __typename?: "Organization";
  samlIntegration?: {
    __typename?: "SamlIntegration";
    id: string;
    idpCertExpiresAt?: number | null;
  } | null;
};

export const WarnIfSamlCertExpiringFragmentDoc = gql`
  fragment WarnIfSamlCertExpiring on Organization {
    samlIntegration {
      id
      idpCertExpiresAt
    }
  }
`;
